'use strict';

import React from 'react';
import PropTypes from 'prop-types';

import appConstants from 'constants/appConstants';

import teamActions from 'actions/TeamActionCreators';
import teamStore from 'stores/TeamStore';
import PageSection from 'components/base/PageSection';
import List from 'components/base/list-components/List';
import ListSection from 'components/base/list-components/ListSection';
import ListItem from 'components/base/list-components/ListItem';
import ListItemCell from 'components/base/list-components/ListItemCell';
import Avatar from 'components/base/Avatar';

import _ from 'underscore';
import utils from 'services/utils';
import constants from 'constants/appConstants';
import personUtils from 'services/people/personUtils';
import moment from 'moment';

const propTypes = {
    error: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.string,
};

class YourManagerWidget extends React.Component {

    constructor(props) {
        super(props);
        this.onTeamChange = this.onTeamChange.bind(this);
        this.state = {};
    }

    componentDidMount() {
        teamStore.addChangeListener(this.onTeamChange);
        setTimeout(function () {
            teamActions.getUsersManagers();
        }, 0);
    }

    componentWillUnmount() {
        teamStore.removeChangeListener(this.onTeamChange);
    }

    onTeamChange() {
        var teams = teamStore.getTeamData();
        this.setState({
            usersManagers: teams.usersManagers,
        });
    }

    render() {
        if (!this.state.usersManagers) {
            return null;
        }

        var loading = this.state.usersManagers.loading;
        var yourManagerContent = [];
        var isManager = false;
        var maxRows = 4;
       
        if (this.state.usersManagers && this.state.usersManagers.items) {
            if (this.state.usersManagers.items.length > 0) {
                yourManagerContent = this.props.teams.usersManagers.items.map(function (manager, index) {
                    var content = []; 

                    if (manager.OfficeNumber && this.props.permissions.isVisible('WorkContact')) {
                        content.push(<div key="0">{utils.formatPhone(manager.OfficeNumber)}</div>);
                    }

                    if (manager.WorkEmail && this.props.permissions.isVisible('WorkContact')) {
                        content.push(<div key="1"><a className="hyperlink" href={"mailto:" + manager.WorkEmail}>{manager.WorkEmail}</a></div>);
                    }

                    var listRowCell = null;
                    
                    if (content) {
                        listRowCell = <ListItemCell content={content} />;
                    }

                    var avatar = <Avatar profile={manager} />;
                    
                    return (
                        <ListItem 
                            key={index} 
                            avatar={avatar}
                            heading={personUtils.getFullName(manager)} 
                            content={listRowCell}
                            multiline
                        />
                    );
                }.bind(this));
            } else {
                yourManagerContent.push(
                    <ListItem key="0" content="You have no managers" />
                );
            }
        }

        return (
            <PageSection id="your-manager-widget">
                <List icon="icon-managers" id={this.props.id} heading={"Your Manager" + (yourManagerContent.length > 1 ? "s" : "")} loading={loading}>
                    <ListSection maxItems={maxRows}>
                        {yourManagerContent}
                    </ListSection>
                </List>
            </PageSection>
        );
    }
}

YourManagerWidget.propTypes = propTypes;

export default YourManagerWidget; 